import { CONSTANTS } from 'client/utils/constants';
import AccessDeniedAuthenetication from '../../assets/images/401&403.svg'
import PageNotFound from '../../assets/images/404.svg'
import InternalErrorServiceUnavailable from '../../assets/images/500 & 503.svg'
import './ErrorHandling.scss';
import { PrimaryButton } from '..';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCommonAPIError } from 'Store/CommonErrorHandler/CommonErrorHandlerAction';

const iconReturn = (status: any) => {
    let src = "";
    switch (status) {
        case "401":
        case "403":
            src = AccessDeniedAuthenetication;
            break;
        case "500":
        case CONSTANTS.ERROR_CODE.STATUS_500:
        case "503":
            src = InternalErrorServiceUnavailable;
            break;
        case "404":
            src = PageNotFound;
            break;
        default:
            break;
    }
    return <img src={src} alt="Error Image" className="error-image" />;
}

const errorNameReturn = (status: any) => {
    let errorName = "";
    switch (status) {
        case "401":
            errorName = 'Authentication Required';
            break;
        case "403":
            errorName = 'Access Denied/Forbidden';
            break;
        case "404":
            errorName = 'Page Not Found';   
            break;
        case "500":
        case CONSTANTS.ERROR_CODE.STATUS_500:
            errorName = 'Internal Server Error';          
            break;
        case "503":
            errorName = 'Service Unavailable';
            break;
        default:
            break;
    }
    return <p className="error-name">{errorName}</p>;
}

const errorDescriptionReturn = (status: any) => {
    let errorDescription = "";
    switch (status) {
        case "401":
            errorDescription = 'Access is allowed only for registrated users.';
            break;
        case "403":
            errorDescription = 'The page you are trying to reach is absolutely forbidden for some reason.';
            break;
        case "404":
            errorDescription = 'The page you are looking for may have been removed, deleted or possibly never existed.';
            break;
        case "500":
        case CONSTANTS.ERROR_CODE.STATUS_500:
            errorDescription = 'The server has been deserted for a while. Please be patient or try again later';
            break;
        case "503":
            errorDescription = 'The server is temporarily busy, Try again later!';
            break;
        default:
            break;
    }
    return errorDescription;
}

const UnauthorizedAccess = (props:any) =>{
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return(<div className='unauthorized-container'>
        <>{errorNameReturn(props?.errorNumber)}</>
        <div className="center-block">           
            <div className="content-section">
                <p className="error-text">ERROR</p>
                <p className="error-number">{props?.errorNumber}</p>
            </div>
            {iconReturn(props?.errorNumber)}          
        </div>
        <>{<p className="error-description">{props?.errorText ? props?.errorText : errorDescriptionReturn(props?.errorNumber)}</p>}</>
        <PrimaryButton className={'mt-3'} text='Reload' onClick={()=>{
            dispatch(setCommonAPIError(''));
            navigate('/ordermanagement');
        }} data-attribute="ErrorHandling_Default_Button" />
    </div> )
}

export default UnauthorizedAccess;